var _circle, _ellipse, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfilePlaceholderImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "url(#paint0_linear_3220_11674)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.9993,
    cy: 36.0001,
    rx: 9.33333,
    ry: 9.33333,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.6673 62.8333C68.6673 68.6322 68.6673 73.3333 50.0007 73.3333C31.334 73.3333 31.334 68.6322 31.334 62.8333C31.334 57.0343 39.6913 52.3333 50.0007 52.3333C60.31 52.3333 68.6673 57.0343 68.6673 62.8333Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3220_11674",
    x1: 50,
    y1: 0,
    x2: 50,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7E6EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F99AB",
    stopOpacity: 0.51
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePlaceholderImg);
export default __webpack_public_path__ + "static/media/profile_placeholder_img.a5df9a4cd265daecc05b997f21b61e5f.svg";
export { ForwardRef as ReactComponent };